import { IFranchise, IFranchiseGroup, IOEM } from "@/Common/interfaces/location";

export const groupFranchisesByOems = (oems: IOEM[]) => {
	return oems
		.map((oem: IOEM) => {
			return oem.franchises.map((item: IFranchise) => {
				if (item.isCombined) {
					return item.groups?.map((groupItem: IFranchiseGroup) => {
						return groupItem.franchiseName.toUpperCase();
					});
				}
				return item.franchise.toUpperCase();
			});
		})
		.flat(Infinity) as string[];
};
